var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeciality20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-width:1.5px;}.c{stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-627 -7400)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(627 7400)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.885 2.646)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-614.109-7381.875s-9.73.083-13.224.1-5.057,4.954-2.328,6.372,10.138.35,11.353,1.19,4.853,6.532,11.766,6.158",
    transform: "translate(-0.889 -0.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-619.058-7393.62l-30.827,30.755v6.683s6.9.719,12.216-7.473a11.608,11.608,0,0,0,0-3.593l7.329-6.971",
    transform: "translate(0 -0.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-618.189-7384.513s8.387-7.433,9.25-8.982.9-3.679-1.692-4.883-4.462,1.972-5.575,3.118",
    transform: "translate(-1.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-638.789-7373.063s-5.085.5-4.422-2.874,6.08-7.352,6.08-7.352",
    transform: "translate(-0.312 -0.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-635.028-7385.42s1.824-2.653,4.477-3.041a41.866,41.866,0,0,1,7.241,0",
    transform: "translate(-0.702 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-612.388-7388.633h6.632",
    transform: "translate(-1.771 -0.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-634.651-7368.078s-.267,2.351.855,3.4,1.8,1,3.634.784c5.7-5.418,7.2-6.925,7.2-6.925",
    transform: "translate(-0.718 -1.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-634.7-7367.751a4.186,4.186,0,0,0,.906,3.1,3.2,3.2,0,0,0,3.634.784c1.354-.525,6.588-6.412,6.588-6.412",
    transform: "translate(3.906 2.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-634.407-7368.229s-.542,2.394.581,3.439a3.36,3.36,0,0,0,3.671,1.015c1.354-.525,3.077-3,3.077-3",
    transform: "translate(7.708 7.112)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality20);
export default __webpack_public_path__ + "static/media/speciality20.c218a53ebdb14197e950336189659d08.svg";
export { ForwardRef as ReactComponent };